export default function getClassNames(classNames: Array<string> = []) {
  return classNames?.join(" ");
}
